import state from './state'
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(Object.keys(state))
  }
}



// WEBPACK FOOTER //
// ./src/store/mixin.js